module.exports = __webpack_public_path__ + "static/media/sound.3e5b71b1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/sound.svg
// module id = 253
// module chunks = 44